export default __webpack_public_path__ + "assets/27578d9cb3448c5b7f4ad286a3e67e8f.png";